import { 
    SET_LOADING_AUTH_REFRESH,
} from "../actions/authActions";

const initialState = {
    loadingAuthRefresh: false
};

const authReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_LOADING_AUTH_REFRESH:
            return {
                ...state,
                loadingAuthRefresh: action.payload
            };
        default:
            return state;
    }
};

export default authReducer;